<template>
    <div>
        <v-container fluid v-if="settings" class="pa-5">
            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Settings</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                        color="info"
                        dark
                        class="mb-2"
                        @click="createSetting"
                >
                    <i class="fas fa-plus mr-2"></i> New Setting
                </v-btn>
            </div>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            clearable
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :loading="this.$apollo.queries.settings.loading"
                        :headers="headers"
                        :items="settings.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="settings.paginatorInfo.lastPage * pageCount"
                        :footer-props="{'items-per-page-options': [20, 40]}"
                >

                    <template v-slot:item.createdAt="{ item }">
                        {{item.createdAt | formatDate('D-MMM-YY hh:mm')}}
                    </template>
                    <template v-slot:item.updatedAt="{ item }">
                        {{item.updatedAt | formatDate('D-MMM-YY hh:mm')}}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn @click="updateSetting(item)" text>
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>

        <v-dialog
                v-model="updateDialog"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline">
                    Update Setting
                </v-card-title>

                <v-card-text>
                    <SettingForm v-model="settingForEdit" ref="updateForm"/>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red darken-1"
                            text
                            @click="updateDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            dark
                            color="light-green"
                            @click="saveUpdate"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="createDialog"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline">
                    Create Setting
                </v-card-title>

                <v-card-text>
                    <SettingForm v-model="settingForEdit" ref="createForm"/>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red darken-1"
                            text
                            @click="createDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            dark
                            color="light-green"
                            @click="create"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import SETTINGS_LIST from "../graphql/Settings/SettingsList.gql";
    import SettingForm from "../components/Setting/Form/SettingForm";
    import SETTINGS_CREATE from "../graphql/Settings/Create.gql"
    import SETTINGS_UPDATE from "../graphql/Settings/Update.gql"

    export default {
        components:{
            SettingForm
        },
        metaInfo: {
            title: 'Settings'
        },
        apollo: {
            settings: {
                query: SETTINGS_LIST,
                variables() {
                    let where = {}
                    if (this.search !== '' && this.search !== null) {
                        where = {column: 'NAME', operator: 'LIKE', value: '%' + this.search + '%'}
                    }

                    let sortField = 'NAME'
                    let sortDirection = this.sortDesc[0] ? 'DESC' : 'ASC'

                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: sortField.toUpperCase(), order: sortDirection},
                    }
                },
                update: data => data.settings
            },
        },
        data() {
            return {
                search: '',
                page: 1,
                pageCount: 20,
                sortBy: ['name'],
                sortDesc: [false],
                settingForEdit: {
                    id: null,
                    name: null,
                    value: null,
                },
                updateDialog: false,
                createDialog: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        value: 'name',
                    },
                    {
                        text: 'Value',
                        align: 'start',
                        value: 'value',
                    },
                    {
                        text: 'Created At',
                        align: 'start',
                        value: 'createdAt',
                    },
                    {
                        text: 'Updated At',
                        align: 'start',
                        value: 'updatedAt',
                    },
                    {
                        text: 'Action',
                        align: 'start',
                        value: 'action',
                    }
                ],
            }
        },
        methods: {
            updateSetting(setting) {
                this.settingForEdit.name = setting.name
                this.settingForEdit.value = setting.value
                this.settingForEdit.id = setting.id
                this.updateDialog = true
            },

            createSetting() {
                this.settingForEdit.name = null
                this.settingForEdit.value = null
                this.settingForEdit.id = null
                this.createDialog = true
            },

            saveUpdate() {
                this.$refs.updateForm.validate().then((valid) => {

                    if(!valid) {
                        return;
                    }

                    this.$apollo.mutate({
                        mutation: SETTINGS_UPDATE,
                        variables: {input: this.settingForEdit}
                    }).then(() => {
                        this.updateDialog = false
                        this.$store.dispatch('notification/addSuccess', 'Setting Updated successful')
                        this.$apollo.queries.settings.refetch()
                    }).catch((error) => {
                        this.$store.dispatch('notification/handleGraphQlError', error)
                    })
                })
            },

            create() {
                this.$refs.createForm.validate().then((valid) => {
                    if(!valid) {
                        console.log(valid)
                        return;
                    }

                    this.$apollo.mutate({
                        mutation: SETTINGS_CREATE,
                        variables: {input: {
                                name: this.settingForEdit.name,
                                value: this.settingForEdit.value,
                            }
                            },
                    }).then(() => {
                        this.createDialog = false
                        this.$store.dispatch('notification/addSuccess', 'Setting created successful')
                        this.$apollo.queries.settings.refetch()
                    }).catch((error) => {
                        this.$store.dispatch('notification/handleGraphQlError', error)
                    })
                })
            },

        },

    }
</script>
